import { registerPlugin } from "@capacitor/core"
import type { AppleAuthPlugin } from "./definitions"
import { AppleAuthWeb } from "./web"

export const AppleAuth = registerPlugin<AppleAuthPlugin>("AppleAuth", {
	web: () => new AppleAuthWeb(),
})
